module.exports = __webpack_public_path__ + "img/cc.6e128379.svg";